export default "__VITE_ASSET__BkEk4PM7__"